<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    :title="$schema.$title"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="submit"
    @close="close"
  >
    <w-datepicker :model="$schema.date" />
  </w-modal>
</template>

<script>
import { Errors } from '@/enums/errors.enum';
import { Successes } from '@/enums/successes.enum';
import { formMixin } from '@/mixins/form';
import { modalMixin } from '@/mixins/modal';
import { notificationsMixin } from '@/mixins/notifications';
import { koResource } from '@/resources/ko.resource';
import schema from '@/schemas/paymentPackReceivedFunds.schema';
import { getPaymentPackDetails } from '@/utils/paymentList';
import { serverError } from '@/utils/serverError';

// @vuese
// Modal ustawiania "Środki wypłacone" dla pojedynczej paczki
// @group Modals
export default {
  mixins: [formMixin, notificationsMixin, modalMixin],
  schema,

  data() {
    return { model: {} };
  },

  computed: {
    paymentPackId() {
      return parseInt(this.$route.params.packId);
    }
  },

  methods: {
    submit() {
      if (this.$schema.$validateAll().length) {
        this.notifyError(Errors.FORM_CORRECT_ERRORS);
        return;
      }
      koResource
        .markAsReceivedFunds({ packId: this.paymentPackId, date: this.$schema.$getData().date })
        .then(() => {
          this.notifySuccess(Successes.KO_PAYMENT_PACK_RECEIVED_FUNDS);
          getPaymentPackDetails(this.$route);
          this.close();
        })
        .catch(err => this.notifyError(serverError(err)));
    }
  }
};
</script>
